export const mapDataForBackend = (scenario) => ({
  name: scenario.name,
  lightGroupId: scenario.group.value,
});
